import {APIActionStatus} from '../Screen';
import {Form} from '../Form';
import {formsStore} from '../FormsStore';
import {Record} from '../Record';

const hasKeys = (record: Record) => {
    return record.keys?.length > 0;
};

export const ensureKeysPresent = async (form: Form) => {
    const activeRow = form?.currentRecord;

    if (activeRow && !hasKeys(activeRow)) {
        const {currentValue, columnId} = form.activeField() || {};
        if (columnId && currentValue) {
            await formsStore.currentScreen?.fieldUpdate?.();
        }
    }
    return hasKeys(activeRow) ? APIActionStatus.passed : APIActionStatus.blocked;
};
